import { useLocation } from "react-router-dom";
import { Dashboard } from "../../models/Dashboard";
import { DashboardItem } from "../../models/DashboardItem";
import { DahsboardUsers } from "../../models/DashboardUsers";
import DocumentList from "../genericcrud/DocumentList";
import DynamicForm from "../genericcrud/DynamicForm";
import { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap"; // Import React-Bootstrap Tabs

const DashboardDetail = () => {
    const location = useLocation();
    const { currentRow } = location.state || {};
    const url = new URL(window.location.href);
    const [keyValueEntries, setKeyValueEntries] = useState([{ key: "", value: "" }]);
    const [showPopup, setShowPopup] = useState(false);

    const [key, setKey] = useState("dashboardItems"); // State to manage active tab


    useEffect(() => {
        const dashboardId = url.pathname.split('/')[2];
        DashboardItem.tableDataUrl = "/dashboard/"+ dashboardId;
        DashboardItem.attributes[1].defaultValue = dashboardId;
        DahsboardUsers.attributes[1].defaultValue = dashboardId;
        DashboardItem.attributes[7].handleSelectChange = (selectedOption, field) => {
            setShowPopup(true);
        };
    }, [url]);

    const handleSelectChangeForPopup = (selectedOption, fieldIndex, type) => {
        setKeyValueEntries((prev) => {
            const updatedEntries = [...prev];
            updatedEntries[fieldIndex][type] = selectedOption.target.value;
            return updatedEntries;
        });
    };

    const handleAddEntry = () => {
        setKeyValueEntries((prev) => [...prev, { key: "", value: "" }]);
    };

    const handleRemoveEntry = (index) => {
        setKeyValueEntries((prev) => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
        setShowPopup(false);
    };
    const popupContent = showPopup && (
        <div className="popup-overlay">
            <div className="popup">
                <h4>Enter Key-Value Entries</h4>
                <div className="form-fields">
                    {keyValueEntries.map((entry, index) => (
                        <div key={index} className="key-value-row">
                            <input
                                type="text"
                                placeholder="Key"
                                value={entry.key}
                                onChange={(e) => handleSelectChangeForPopup(e, index, "key")}
                                className="key-input"
                            />
                            <input
                                type="text"
                                placeholder="Value"
                                value={entry.value}
                                onChange={(e) => handleSelectChangeForPopup(e, index, "value")}
                                className="value-input"
                            />
                            <button
                                className="remove-btn"
                                onClick={() => handleRemoveEntry(index)}
                            >
                                Remove
                            </button>
                        </div>
                    ))}
                    <button className="add-btn" onClick={handleAddEntry}>
                        Add Entry
                    </button>
                </div>
                <div className="popup-actions">
                    <button onClick={handleSubmit} className="submit-btn">
                        Submit
                    </button>
                    <button onClick={() => setShowPopup(false)} className="close-btn">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <div className="row justify-content-end my-3">
                <div className="col-12">
                    <div className="row">
                        <div className="col-3">
                            <div className="card bg-light rounded">
                                <div className="card-body">
                                    <div className="text-center">
                                        <h5>Dashboard Detail</h5>
                                    </div>
                                    <DynamicForm
                                        isModel={false}
                                        row={currentRow}
                                        documentMeta={Dashboard}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-9">
                            <div className="card bg-light rounded">
                                <div className="card-body">
                                    <div className="text-center">
                                        <h5>Dashboard Details</h5>
                                    </div>
                                    {/* Tabs for Dashboard Items and Users */}
                                    <Tabs
                                        id="dashboard-tabs"
                                        activeKey={key}
                                        onSelect={(k) => setKey(k)}
                                        className="mb-3"
                                    >
                                        <Tab eventKey="dashboardItems" title="Dashboard Items">
                                            <DocumentList documentMeta={DashboardItem} isModel={false} />
                                        </Tab>
                                        <Tab eventKey="users" title="Users for Dashboard">
                                            {/* Placeholder for user-related data */}
                                            <DocumentList
                                                documentMeta={DahsboardUsers}
                                                isModel={true}
                                            />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardDetail;
